// extracted by mini-css-extract-plugin
module.exports = {"link":"A_link__TQS0A"};